export const GET_DELETE_CONFIRMATION_TEXT = (respondentName: string) => `Are you sure you would like to delete this response from ${respondentName}?`;

export const DELETE_TEXT = "Delete";
export const CANCEL_TEXT = "Cancel";

export const COACH_SELF_ASSESSMENT_NOTE =
  "This report reflects your self-assessment results only and serves as a baseline for your leadership development. A separate student survey will be administered at a later date. Once student feedback has been collected, a comparison table will be added to that report, allowing you to compare your self-assessment results with your students' feedback.";



// WEBPACK FOOTER //
// ./src/pages/director/evaluation/constants.ts